import React, { useMemo } from "react";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import type { Meta, StoryObj } from "@storybook/react";
import CreateMissionsManager from "../../../contexts/CreateMissionManager";
import CreateMissionDeductions from "../../../screens/create-mission/CreateMissionDeductions";
import { buildContract, buildMission } from "../../factories";
import { EarningType, Repetition, Unit } from "../../../__generated__/graphql";
import { RecoilRoot } from "recoil";
import { newMissionState } from "../../../atoms/core";

type RepetitionMode = "With" | "Without";

function InnerStory() {
    return (
        <MockedProvider mocks={[]}>
            <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                <CreateMissionsManager
                    onValidate={(mission) => {
                        alert(
                            `Screen Validated fee count: ${mission.currentContract?.fees?.length}`,
                        );
                    }}
                >
                    <CreateMissionDeductions />
                </CreateMissionsManager>
            </VStack>
        </MockedProvider>
    );
}

function StoryComponent({ repetitionMode }: { repetitionMode: RepetitionMode }) {
    const mission = useMemo(
        () =>
            buildMission({
                currentContract: buildContract({
                    earningType:
                        repetitionMode == "With" ? EarningType.Hourly : EarningType.Package,
                    workingTimeClassicSpec:
                        repetitionMode === "Without"
                            ? {
                                  repetition: Repetition.None,
                                  unit: Unit.Hours,
                                  unitCount: 20,
                                  dailyHours: null,
                              }
                            : {
                                  repetition: Repetition.Week,
                                  unit: Unit.Hours,
                                  unitCount: 42,
                                  dailyHours: null,
                              },
                }),
            }),
        [repetitionMode],
    );
    return (
        <RecoilRoot
            initializeState={(snap) => {
                snap.set(newMissionState, mission);
            }}
        >
            <MockedProvider mocks={[]}>
                <InnerStory />
            </MockedProvider>
        </RecoilRoot>
    );
}

const meta = {
    title: "CreateMission/Deductions",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const WithRepetition: Story = {
    args: {
        repetitionMode: "With",
    },
};
export const NoRepetition: Story = {
    args: {
        repetitionMode: "Without",
    },
};
